<p-panel *ngIf="displayUploadVirtualPrinterPanel" [header]="'APPLICATION.CONTAINER_COMPONENT.MODAL_UPLOAD_VIRTUAL_PRINTER' | translate" [style]="{margin: '5px'}" [toggleable]="true" (onAfterToggle)="initData()">
  <p-tabView id="upload-virtual-printer-panel" (onChange)="switchTabs($event); getVersionList()">
    <!-- upload version generique -->
    <p-tabPanel class="p-tabview-panel upload-virtual-printer-panel_content" header="{{ 'VIRTUAL_PRINTER.UPLOAD_COMPONENT.GENERIC_VERSION' | translate }}">
        <p-fieldset  id="general" [styleClass]="'fieldset'" legend="{{ 'VIRTUAL_PRINTER.UPLOAD_COMPONENT.GENERAL' | translate }} : ">
          <span id="release" *ngIf="uploadGenericVersionAvailable"> {{ 'VIRTUAL_PRINTER.UPLOAD_COMPONENT.RELEASE' | translate }} : {{genericVersion}}</span> <br />
          <br />
          <label for="releaseGenericNotes"> {{ 'VIRTUAL_PRINTER.COMMON.DESCRIPTION' | translate }} : </label>
          <textarea id="releaseGenericNotes"  name="releaseGenericNotes"  [(ngModel)]="genericPrinterDescription" pInputTextarea placeholder="{{ 'VIRTUAL_PRINTER.UPLOAD_COMPONENT.GENERIC_DESCRIPTION_PLACEHOLDER' | translate }}" (input)="handleInputErrors( $event, 'description_required')"></textarea>
          <!-- <label for="virtualPrinteFiles"> Sélection des fichiers : </label> -->
        </p-fieldset>
        <p-fieldset id="file_selection" [styleClass]="'fieldset'" legend="{{ 'VIRTUAL_PRINTER.UPLOAD_COMPONENT.FILE_SELECTION' | translate }} :">
          <div class="grid fichiers" *ngFor="let upload of virtualPrinterPackages">
              <div class="col-3" >
                <span class="file_descriptor"> {{ 'VIRTUAL_PRINTER.UPLOAD_COMPONENT.FILE' | translate }} {{ upload.ext.toUpperCase() }} : </span>
              </div>
              <div *ngIf="upload.files.length < 2; else otherLength" class="col-9">
                <input id="{{ 'virtualPrinterUpload_' + upload.files[ 0 ].target }}" type="file" accept="{{ upload.files[ 0 ].accept }}" style="display: none" (change)="updateVirtualPrinterUploadFileList( $event, upload.files[ 0 ].target, upload.files[ 0 ].error )"  />
                <button pButton type="file" class="upload_VP_ajouterFicher" label="... " (click)="addFiles($event, upload.files[ 0 ].target )"></button>
                <span *ngIf="upload.files[ 0 ].uploadable">
                    <span class="file_descriptor" *ngIf="!upload.files[ 0 ].valid"><i class="fa fa-times" style="color: #d95334"></i></span>
                    <span class="file_descriptor" *ngIf="upload.files[ 0 ].valid"><i class="fa fa-check" style="color: #5cb85c"></i></span>
                </span>
              </div>
              <ng-template #otherLength >
                <div class="col-4" *ngFor="let file of upload.files">
                  <input id="{{ 'virtualPrinterUpload_' + file.target }}" type="file" accept="{{ file.accept }}" style="display: none" (change)="updateVirtualPrinterUploadFileList( $event, file.target, file.error )"  />
                  <button pButton type="file" class="upload_VP_ajouterFicher" label=" {{ file.arch  }} " (click)="addFiles($event, file.target )"></button>
                  <span *ngIf="file.uploadable">
                          <span class="file_descriptor" *ngIf="!file.valid"><i class="fa fa-times" style="color: #d95334"></i></span>
                          <span class="file_descriptor" *ngIf="file.valid"><i class="fa fa-check" style="color: #5cb85c"></i></span>
                        </span>
                </div>
                <div class="col-1"></div>
              </ng-template>
          </div>
        </p-fieldset>
        <p-fieldset *ngIf="uploadOK" legend="{{ 'VIRTUAL_PRINTER.COMMON.PROBLEMS' | translate }} :" id="displayErrors">
          <ul id="upload_generic_error_list">
            <ng-container *ngFor="let error of uploadGenericMessages.errors">
              <li *ngIf="error.active"> {{ error.message }} </li>
            </ng-container>
          </ul>
          <p *ngIf="uploadGenericMessages.success.active" >
            <span> {{ uploadGenericMessages.success.message }}</span>
          </p>
        </p-fieldset>
        <br />
        <div class="button_line">
          <input pButton id="submitUploadVirtualPrinter" class="p-button-success" type="button" value="{{ 'VIRTUAL_PRINTER.COMMON.SUBMIT' | translate }}" (click)="uploadVirtualPrinter($event)" [disabled]="disallowForm" />
          <input pButton id="resetUploadVirtualPrinter" class="p-button-info"  type="reset" value="{{ 'VIRTUAL_PRINTER.COMMON.CANCEL' | translate }}" (click)="initData()" />
        </div>
        <br /><br />
    </p-tabPanel>
    <!-- upload version specifique -->
    <p-tabPanel [ngClass]="['p-tabview-panel', 'upload-virtual-printer-panel_content']" header="{{ 'VIRTUAL_PRINTER.UPLOAD_COMPONENT.SPECIFIC_VERSION' | translate }}">
      <p-fieldset *ngIf="uploadOK" [styleClass]="'fieldset'" legend="{{ 'VIRTUAL_PRINTER.UPLOAD_COMPONENT.GENERAL' | translate }} :">
        <div class="form_line">          </div>
        <label for="versions"> {{ 'VIRTUAL_PRINTER.COMMON.VERSION' | translate }} : </label>
        <p-dropdown id="versions" [options]="versionList" (onChange)="updatePackageVersion($event)"></p-dropdown> <br />
          <div class="form_line">
            <label for="packageName"> {{ 'VIRTUAL_PRINTER.COMMON.NAME' | translate }} : </label>
            <input pInputText id="packageName" name="packageName" [(ngModel)]="packageName" (input)="handleInputErrors( $event, 'name_required')"/>
          </div>
          <div class="form_line">
            <label for="releasePackagedNotes"> {{ 'VIRTUAL_PRINTER.COMMON.DESCRIPTION' | translate }} : </label>
            <textarea id="releasePackagedNotes" [(ngModel)]="specificPrinterDescription" name="releasePackagedNotes" pInputTextarea placeholder="Description de la nouvelle version d'imprimante virtuelle, à destination des clients ..." (input)="handleInputErrors( $event, 'description_required')"></textarea>
          </div>
        </p-fieldset>
        <p-fieldset *ngIf="uploadOK"  [styleClass]="'fieldset'" legend="{{ 'VIRTUAL_PRINTER.UPLOAD_COMPONENT.FILE_SELECTION' | translate }} :">
          <div class="grid fichiers">
            <div class="col-3">
              {{ 'VIRTUAL_PRINTER.UPLOAD_COMPONENT.FILE' | translate }}&nbsp; {{ virtualPrinterPackagedFiles[ 0 ].ext }} :
            </div>
            <ng-container  *ngFor="let file of virtualPrinterPackagedFiles[ 0 ].files" id="virtualPrinteFiles" name="virtualPrinteFiles">
              <div class="col-4">
                <input id="{{ 'virtualPrinterUpload_' + file.target }}" type="file" accept="{{ file.accept }}" style="display: none" (change)="updateVirtualPrinterUploadFileList( $event, file.target, file.error )"  />
                <button pButton type="file" class="upload_VP_ajouterFicher" label="{{ file.arch }}" (click)="addFiles($event, file.target )"></button>
                <span *ngIf="file.uploadable">
                    <span class="file_descriptor" *ngIf="!file.valid"><i class="fa fa-times" style="color: #d95334"></i></span>
                    <span class="file_descriptor" *ngIf="file.valid"><i class="fa fa-check" style="color: #5cb85c"></i></span>
                  </span>
              </div>
            </ng-container>
          </div>
        </p-fieldset>
        <br />
        <p-fieldset *ngIf="uploadOK" id="displayErrors2" [styleClass]="'fieldset'" legend="{{ 'VIRTUAL_PRINTER.COMMON.PROBLEMS' | translate }} :">
          <ul id="upload_package_error_list">
            <ng-container *ngFor="let error of uploadPackageMessages.errors">
              <li *ngIf="error.active"> {{ error.message }} </li>
            </ng-container>
          </ul>
          <p *ngIf="uploadPackageMessages.success.active" >
            <span> {{ uploadPackageMessages.success.message }}</span>
          </p>
        </p-fieldset>
        <br />
        <div>
          <input pButton id="submitUploadPackagedVirtualPrinter" class="p-button-success" type="button" value="{{ 'VIRTUAL_PRINTER.COMMON.SUBMIT' | translate }}" (click)="uploadVirtualPrinter($event)" [disabled]="disallowForm" />
          <input pButton id="resetUploadPackagedVirtualPrinter" type="reset" class="p-button-info" value="{{ 'VIRTUAL_PRINTER.COMMON.CANCEL' | translate }}" (click)="initData()" />
        </div>
        <br /><br />
    </p-tabPanel>
  </p-tabView>
    <br />
</p-panel>

